import type { ColDefField, Context, ServerColDef, ValueFormatterParams } from '@cmg/data-grid';

export const valueFormatter = <TData, TValue extends string>({
  value,
  context: { intl },
}: ValueFormatterParams<TData, TValue, Context>) =>
  intl.formatDate(value, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });

export function createModifiedOnColDef<T>(field: ColDefField<T, string>): ServerColDef<T, string> {
  return {
    field,
    headerName: 'Last Updated',
    minWidth: 180,
    filter: 'agDateColumnFilter',
    valueFormatter,
    filterParams: {
      filterOptions: ['lessThan', 'greaterThan'],
    },
  };
}
